import { FC } from 'react'
import clsx from 'clsx'
import PdMedia from '@/components/pd-media/pd-media'
import useScrollScale from '@/hooks/tools/use-scroll-scale'
import { useMobileDetector } from '@/hooks/use-mobile-detector'

type Section2Type = {
  mediaUrl: string
  theme?: string
  maskColor?: string
  maskDegree?: number
}

const Section2: FC<Section2Type> = ({ mediaUrl = '', theme, maskColor = 'transparent', maskDegree = 180 }) => {
  const isMobile = useMobileDetector()
  const containerRef = useScrollScale({
    targetSelector: '.target-section2',
  })

  return (
    <div className={clsx('w-full h-fit relative', `pd-theme-${theme} bg-anti-blk`)}>
      <div className={clsx('w-full', 'h-[177.86vw] laptop:h-[56.25vw] overflow-hidden')} ref={containerRef}>
        <PdMedia src={mediaUrl} mask={false} className="target-section2 scale-200" />
      </div>
      <div
        className={clsx('absolute top-0 left-0 w-full h-[50%] pt-15 laptop:pt-28')}
        style={{
          background: `linear-gradient(${maskDegree}deg, ${maskColor}, transparent)`,
        }}
      ></div>
    </div>
  )
}

export default Section2
